module.exports = __webpack_public_path__ + "img/trinity_core_trio.413b1da0.png";